import { render, staticRenderFns } from "./overdue_unrealised_benefits.vue?vue&type=template&id=8c130bea&scoped=true&"
import script from "./overdue_unrealised_benefits.vue?vue&type=script&lang=js&"
export * from "./overdue_unrealised_benefits.vue?vue&type=script&lang=js&"
import style0 from "./overdue_unrealised_benefits.vue?vue&type=style&index=0&id=8c130bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c130bea",
  null
  
)

export default component.exports